// React
import React, { Component } from "react";
import PropTypes from "prop-types";
// i18n
import { withNamespaces } from "react-i18next";

class FileInput extends Component {
  constructor(props) {
    super(props);
    this.state = {
      touched: false,
      value: ""
    };
  }

  getInputState() {
    const { required, requiredMessage, t } = this.props;
    const invalidInput = {
      hasError: true,
      style: {
        backgroundColor: "#fff0f0",
        borderColor: "#A90329"
      }
    };
    const validInput = {
      hasError: false,
      style: {
        backgroundColor: "#f0fff0",
        borderColor: "#7DC27D"
      }
    };
    const neutralInput = { hasError: false, style: {} };
    return this.state.touched
      ? this.state.value
        ? validInput
        : required
        ? {
            ...invalidInput,
            errorMessage:
              requiredMessage ||
              t("modules.localization.register.authenticated.error.invalidFields.default")
          }
        : neutralInput
      : neutralInput;
  }

  render() {
    const { buttonLabel, label, placeholder } = this.props;
    const inputState = this.getInputState();
    return (
      <section onMouseLeave={() => this.setState({ touched: true })}>
        {label && <label className="label">{label}</label>}
        <div className="input input-file">
          <span className="button">
            <input
              id="file2"
              onChange={(e) => this.setState({ value: e.target.value })}
              type="file"
            />
            {buttonLabel}
          </span>
          <input
            placeholder={placeholder}
            readOnly
            style={{ ...inputState.style }}
            type="text"
            value={this.state.value}
          />
          <em className="invalid" style={{ height: 30, minHeight: 30 }}>
            {inputState.hasError && inputState.errorMessage}
            &nbsp;
          </em>
        </div>
      </section>
    );
  }
}

FileInput.defaultProps = {
  placeholder: "",
  required: false
};

FileInput.propTypes = {
  buttonLabel: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  requiredMessage: PropTypes.string,
  t: PropTypes.func.isRequired
};

export default withNamespaces()(FileInput);
